import { byId, notyf, tag } from "../utils";
import * as skylineApi from '../skylineApi'

import DroneTrail from '../views/droneTrail'
import ProgressBar from "../views/progressBar"
import RoamEvents from '../views/roamEvents';
import { MissionInfo } from '../views/missionInfo';
import RadioCard from "../views/radioCard";
import SignalLines from "../views/signalLines";
import MissionGrsMarkers from "../views/missionGrsMarkers";
import ARSMarker from "../views/arsMarker";
import RegionADSB from "../views/regionADSB";
import * as missionManager from '../managers/mission'
import * as globalAirTraffic from "../views/globalAirTraffic"

const root = byId("missionTemplate")

let mission
let plugins = []
let overlay

export default function index(app) {
	app.router.on('/missions/:id', (match) => {
		console.log("Drawing the mission route")

		const id = parseInt(match.data.id)

		mission = missionManager.getMission(id)
		window.mission = mission
		const content = root.content.cloneNode(true)
		const sidebar = content.firstElementChild
		const radiosRoot = content.firstElementChild.getElementsByClassName("assigned-radios")[0]

		app.setContent(content, () => {
			console.log("Leaving the mission route")
			for (const plugin of plugins) {
				plugin.cleanup()
			}
			plugins = []
			missionManager.clearMission(mission)
			removeOverlay(overlay)

			// show all the global stuff
			walkChildren(globalOverlay, child => child.layer && child.layer.addTo(mymap))
		})

		if (mission.serverState.bounds) {
			const bounds = L.latLngBounds([
				[mission.serverState.bounds.north, mission.serverState.bounds.west],
				[mission.serverState.bounds.south, mission.serverState.bounds.east]
			])
			mymap.flyToBounds(bounds)
		}

		overlay = addOverlay("Mission " + id)

		plugins.push(
			new DroneTrail(mission, overlay),
			new ProgressBar(mission, byId("replayTimeline")),
			new RoamEvents(mission, byId("replayTimeline")),
			new MissionInfo(mission, byId("missionInfo")),
			new SignalLines(mission, overlay),
			new ARSMarker(mission, overlay),
			new RegionADSB(mission, overlay),
			new MissionGrsMarkers(mission, overlay)
		)

		plugins.push(new RadioCard(mission, skylineApi.getDevice(mission.serverState.arsDeviceId), radiosRoot))
		for (const deviceId of mission.serverState.grsDeviceIds) {
			const device = skylineApi.getDevice(deviceId)
			plugins.push(new RadioCard(mission, device, radiosRoot))
		}

		const startBtn = sidebar.querySelector(".start-mission")
		startBtn.disabled = false
		startBtn.addEventListener("click", () => {
			if (startBtn.disabled) {
				console.error("Got a click while disabled")
				return
			}
			// Start the spinner
			startBtn.disabled = true
			const spinner = tag("div", { class: "spinner" })
			startBtn.appendChild(spinner)
			skylineApi.startMission(mission.serverState).then((missionInfo) => {
				// Remove the spinner and route forward
				mission.serverState = missionInfo
				mission.connect()
			}).catch((err) => {
				startBtn.disabled = false
				notyf.error(err.message)
			}).finally(() => {
				startBtn.removeChild(spinner)
			})
		})
		const endBtn = sidebar.querySelector(".end-mission")
		endBtn.disabled = false
		endBtn.addEventListener("click", () => {
			endBtn.disabled = true
			const spinner = tag("div", { class: "spinner" })
			endBtn.appendChild(spinner)
			skylineApi.stopMission(mission.serverState).then((missionInfo) => {
				if (!mission.isLive) {
					mission.updateServerState(missionInfo)
				}
			}).catch((err) => {
				endBtn.disabled = false
				notyf.error(err.message)
			}).finally(() => {
				endBtn.removeChild(spinner)
			})
		})

		// hide all the global stuff
		walkChildren(globalOverlay, child => child.layer && child.layer.removeFrom(mymap))
	})
}

function walkChildren(root, callback) {
	if (!root.children) return
	for (const child of root.children) {
		callback(child)
		walkChildren(child, callback)
	}
}